export default __webpack_public_path__ + "static/media/apple-wallet.dfac8fa0.png";